module.exports = __webpack_public_path__ + "static/media/13.ab28d031.jpg";